module.exports = __webpack_public_path__ + "media/05.5dec02f8.mp3";